const ClientModal = (params) =>{
    const {value, data, selectOptions, clientAuthorizationRender} = params;

    const options = selectOptions.filter((opt) => opt.project_id === data.project_id ||
                        (data.related_ibge !== null && opt.ibge === data.related_ibge));

    return (
        <>
            <div className={"w-full h-full min-h-[32px] absolute top-0 left-0 mx-1"} onClick={() => clientAuthorizationRender(data, options, value)}>
                <p>{value?.label}</p>
            </div>
        </>
    );
};

export default ClientModal;
